<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <div
    ref="modalRef"
    :id="popId"
    class="modal"
    :class="{
      'type-mo-full': props.typeMoFull,
      'is-hd-left-attached': props.isHdLeftAttached,
      'is-hd-right-attached': props.isHdRightAttached,
      'only-mo': props.onlyMo,
      'is-quick-attached': props.isQuickAttached,
    }"
    tabIndex="-1"
  >
    <slot> </slot>
  </div>
</template>
<script setup>
import {
  onMounted,
  defineProps,
  onBeforeUnmount,
  ref,
  nextTick,
  computed,
} from "vue";
import { v4 as uuidv4 } from "uuid";
import * as store from "@/store";
import * as cmUtil from "@/utils/cmUtil.js";

const { isMobile } = cmUtil.useDeviceType();

const applicationStore = store.useApplicationStore();

const popId = ref(`MODAL_${uuidv4()}`);

const modalRef = ref(null);

const props = defineProps({
  typeMoFull: {
    type: Boolean,
    default: false,
  },
  isHdLeftAttached: {
    type: Boolean,
    default: false,
  },
  isHdRightAttached: {
    type: Boolean,
    default: false,
  },
  onlyMo: {
    type: Boolean,
    default: false,
  },
  isQuickAttached: {
    type: Boolean,
    default: false,
  },
  isPcNoDimm: {
    // PC 모드 에서 스크롤 방지처리를 제외하는지 여부
    type: Boolean,
    default: false,
  },
});

let timerId = null;
let lastFocusedElement = ref(null);

onMounted(() => {
  if (isDimmPop.value) applicationStore.addPopId(popId.value);
  calcModalContainerHeight();
  setupFocusTrap(modalRef.value);
  lastFocusedElement.value = document.activeElement;

  timerId = setInterval(() => {
    calcModalContainerHeight();
  }, 1000);

  // setTimeout(() => {
  //   setupFocusTrap(modalRef.value);
  //   lastFocusedElement.value = document.activeElement;
  // }, 1000);
});

onBeforeUnmount(() => {
  applicationStore.removePopId(popId.value);

  if (timerId) {
    clearInterval(timerId);
  }
});

const isDimmPop = computed(() => {
  let isDimm = true;

  if (props.isPcNoDimm && !isMobile.value) {
    isDimm = false;
  }

  return isDimm;
});

const calcModalContainerHeight = () => {
  nextTick(() => {
    const modal = document.querySelector(`#${popId.value}`);
    const header = modal.querySelector(".dialog-header");
    const footer = modal.querySelector(".dialog-footer");
    const hasMoFull = modal.classList.contains("type-mo-full"); // MO 풀팝업 유형

    if (modal) {
      // 헤더와 푸터의 높이 계산
      const modalPadding = hasMoFull ? 0 : 40; // modal 상하 padding
      const headerHeight = header ? header.offsetHeight : 0;
      const footerHeight = footer ? footer.offsetHeight : 0;

      const totalHeight = headerHeight + footerHeight + modalPadding;

      // 컨테이너의 max-height 계산 (예: 100vh - totalHeight)
      const containerMaxHeight = `calc(100dvh - ${totalHeight}px)`;

      // 인라인 스타일로 --modal-container-height 추가
      // 2024-12-30 수정
      modal.style.setProperty("--modal-container-height", containerMaxHeight);
    }
  });
};

const setupFocusTrap = (el) => {
  // 팝업 내부의 포커스 가능한 요소들
  const focusableElements = el.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  if (focusableElements.length > 0) {
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    firstElement.focus();

    el.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        applicationStore.removePopId(popId.value);
      }

      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  } else {
    el.focus();
  }
};
</script>
